import path, { createRouteObject } from 'Router/path'
import component from 'Components/index'
import { RouteRecordRaw } from 'vue-router';

const router: RouteRecordRaw[] = [
    createRouteObject({
        path: path.shopList,
        component: component.ShopLandingPage
    }),
    createRouteObject({
        path: path.shopForm,
        component: component.ShopFormPage
    }),
    createRouteObject({
        path: path.shopDetail, 
        component: component.ShopDetailPage
    })
]
export default router;